import { Type } from "class-transformer";
import { Calendar } from "./Calendar";

export class CalendarEventInstance {
    calendarEventId = 0;
    calendarId = 0;
    @Type(() => Calendar)
    calendar: Calendar;
    outlookEventId: string;
    id = 0;
}
